import angular from 'angular';

import ProfileService from './ProfileService';
import ProfileComponent from './ProfileComponent';
import ProfileGroupsComponent from './profileGroups/profileGroupsComponent';
import ProfileInfoComponent from './profileInfo/ProfileInfoComponent';
import TwoFactorAuthComponent from './twoFactorAuth/TwoFactorAuthComponent';

export default angular
  .module('petroCloud.profile', [
    'ngSails',
    'angular-growl'
  ])
  .service('ProfileService', ProfileService)
  .component(ProfileComponent.name, ProfileComponent)
  .component(ProfileGroupsComponent.name, ProfileGroupsComponent)
  .component(ProfileInfoComponent.name, ProfileInfoComponent)
  .component(TwoFactorAuthComponent.name, TwoFactorAuthComponent)
  .name;
